import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { StorageConsts } from 'src/app/consts/storage';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {
  constructor(
    private activeRoute: ActivatedRoute,
    private storage: LocalStorageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe((param) => {
      this.storage.set(StorageConsts.ORDER_ID, this.decode(param.id));
      this.storage.set(StorageConsts.PDF_STATUS, 'none');
      this.router.navigate(['main']);
    });
  }
  decode(str): string {
    return str
      ? str.toString().replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
      : '';
  }
}
